import { isString, isUndefined } from "lodash-es";

export type THtml = string;

export const htmlType = (defaultValue?: any) => (value?: any) =>
  isString(value) ? value : !isUndefined(defaultValue) ? defaultValue : null;
